import { PlateOption } from '@paragon/contract-library';

export function plateOptionsAreEqual(plateOne: PlateOption, plateTwo: PlateOption) {
  return (
    plateOne.plateType === plateTwo.plateType &&
    plateOne.geometryType === plateTwo.geometryType &&
    plateOne.tangiblePlateTypesForComboPlateType.length === plateTwo.tangiblePlateTypesForComboPlateType.length &&
    plateOne.tangiblePlateTypesForComboPlateType.every((tangiblePlateType) =>
      plateTwo.tangiblePlateTypesForComboPlateType.includes(tangiblePlateType),
    ) &&
    plateOne.width === plateTwo.width &&
    plateOne.length === plateTwo.length
  );
}
